<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">
                    {{ $t("RequesterName") }}
                  </th>
                  <th style="width: 14%" class="border-0">
                    {{ $t("RequesterUsername") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Departman") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Supplier") }}
                  </th>

                  <th style="width: 10%" class="border-0">
                    {{ $t("CurrencyType") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("CurrencyRate") }}
                  </th>

                  <th style="width: 13%" class="border-0">
                    {{ $t("DeliveryDate") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("CreateOn") }}
                  </th>
                  <th style="width: 40%" class="border-0">
                    {{ $t("Description") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%" class="border-0">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.supplierInfo ? model.supplierInfo.supplierName : "-"
                    }}
                  </td>

                  <td style="width: 8%" class="border-0">
                    <div v-if="model.invoiceCurrencyInfo">
                      {{
                        model.invoiceCurrencyInfo.currencyType === 1
                          ? "ریال"
                          : model.invoiceCurrencyInfo.currencyType === 2
                          ? "دلار"
                          : model.invoiceCurrencyInfo.currencyType === 3
                          ? "درهم"
                          : "-"
                      }}
                    </div>
                  </td>
                  <td style="width: 8%" class="border-0">
                    {{
                      model.invoiceCurrencyInfo
                        ? model.invoiceCurrencyInfo.rate
                        : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <td style="width: 33%" class="border-0">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="model.invoiceItems && model.invoiceItems.length > 0"
          >
            <vs-table
              :data="model.invoiceItems"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 30%">{{ $t("ProductName") }}</th>
                <th style="width: 10%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <th style="width: 10%">{{ $t("UnitPrices") }}</th>
                <th style="width: 10%">{{ $t("AmountSourceCurrencyWithDeduction") }}</th>

                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ row.invoiceProductInfo.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.invoiceProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td>
                  {{ row.invoiceProductInfo.itemCode }}
                  </vs-td>

                  <vs-td>
                    {{ row.unitOfMeasure.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <vs-td>
                    {{ formatPrice(row.unitPrice) }}
                  </vs-td>
                  <vs-td>
                    {{ row.unitPriceAfterDeductionAndIncrease ? formatPrice(row.unitPriceAfterDeductionAndIncrease) :'-'}}
                  </vs-td>
                  <vs-td>
                    {{ formatPrice(row.amount) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end mt-3 w-full px-5">
            <table class="basic-tbl w-1/5 total" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">
                    {{ $t("TotalAmount") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.totalAmount ? formatPrice(model.totalAmount) : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        model.invoiceDeductionAndIncreases &&
        model.invoiceDeductionAndIncreases.length > 0
      "
      class="vx-card mt-5"
    >
      <div class="vx-card__body card-body">
        <h3>
          {{ $t("DeductionAndIncrease") }}
        </h3>
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="z-0 relative">
                <tr>
                  <th style="width: 5%">#</th>
                  <th style="width: 10%">
                    {{ $t("DeductionAndIncreaseType") }}
                  </th>
                  <th style="width: 10%">{{ $t("ToleranceType") }}</th>
                  <th style="width: 10%">{{ $t("Amounts") }}</th>
                  <th style="width: 10%">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in model.invoiceDeductionAndIncreases">
                  <td>{{ index + 1 }}</td>
                  <td style="width: 10%">
                    <div>
                      {{
                        row.deductionAndIncreaseType &&
                        row.deductionAndIncreaseType === 1
                          ? "کسر"
                          : "اضافه"
                      }}
                    </div>
                  </td>
                  <td style="width: 10%">
                    <div>
                      {{
                        row.toleranceType && row.toleranceType === 1
                          ? "درصدی"
                          : "مقداری"
                      }}
                    </div>
                  </td>

                  <td style="width: 10%">
                    <div>
                      {{ row.amount ? formatPrice(row.amount) : "-" }}
                    </div>
                  </td>
                  <td style="width: 30%">
                    <div>
                      {{ row.description ? row.description : "-" }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  data() {
    return {
      allUnits: [],
      headerInfo: {},
      model: {},
      editable: true,
      editClicked: false,
      productName: "",
      modelNumber: "",
      amount: 0,
      unit: {},
    };
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchInvoicesbyId: "invoice/fetchInvoicesbyId",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchInvoicesbyId(id).then((r) => {
        this.model = r;
      });
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style>
body[dir="rtl"] table thead th {
  position: static;
}
.total thead {
  border: 1px solid;
}
#colored-table thead tr th{
  color: white;
}
</style>
